var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticStyle: {
        height: "100%",
        display: "flex",
        "flex-direction": "column"
      }
    },
    [
      _c(
        "v-card-text",
        { staticStyle: { "flex-grow": "1" } },
        [
          _c(
            "v-layout",
            { staticClass: "font-weight-bold" },
            [
              _c("v-flex", { staticClass: "word-break" }, [
                _vm._v(_vm._s(_vm.address.siteName))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c("v-flex", { staticClass: "word-break" }, [
                _vm._v(_vm._s(_vm.address.fullName))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.address.company
            ? _c(
                "v-layout",
                [
                  _c("v-flex", { staticClass: "word-break" }, [
                    _vm._v(_vm._s(_vm.address.company))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c("v-flex", { staticClass: "word-break" }, [
                _vm._v(_vm._s(_vm.address.address1))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.address.address2
            ? _c(
                "v-layout",
                [
                  _c("v-flex", { staticClass: "word-break" }, [
                    _vm._v(_vm._s(_vm.address.address2))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c("v-flex", { staticClass: "word-break" }, [
                _vm._v(
                  _vm._s(_vm.address.city) +
                    " - " +
                    _vm._s(_vm.address.state) +
                    " - " +
                    _vm._s(_vm.address.zipCode)
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.address.countryCode
            ? _c(
                "v-layout",
                [
                  _c("v-flex", { staticClass: "word-break" }, [
                    _vm._v(_vm._s(_vm.address.countryCode))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.address.partyId
            ? _c(
                "v-layout",
                [
                  _c("v-flex", { staticClass: "word-break" }, [
                    _vm._v(_vm._s(_vm.address.partyId))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c("v-flex", { staticClass: "word-break" }, [
                _vm._v(_vm._s(_vm.address.phone))
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c(
            "v-layout",
            { attrs: { "justify-space-around": "", "text-xs-center": "" } },
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        small: "",
                        disabled: _vm.address.isAmazon
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("edit")
                        }
                      }
                    },
                    [_vm._v("Edit")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        small: "",
                        disabled: _vm.address.isAmazon
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("delete")
                        }
                      }
                    },
                    [_vm._v("Delete")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc318c80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc318c80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelAddressCard.vue
// module id = null
// module chunks = 